export default __webpack_public_path__ + "static/media/Product-List.fe379b38.jpg";